import "./blind.scss";

class Event {
    constructor(toDisplay, start=null, end=null, displayTime = null) {
        this.start = start;
        this.end = end;
        this.toDisplay = toDisplay;
        this.displayTime = displayTime;
    }

    updateFromLast(event) {
        if (this.displayTime == null && event.start != null) {
            this.displayTime = new Date(event.start.valueOf());
        }
    }

    updateFromNext(event) {
        if (this.end == null && event.start != null) {
            this.end = new Date(event.start.valueOf());
        }
    }

    render(showAll=false) {
        if (this.start == null || this.end == null || this.displayTime == null) {
            throw Error("Start, end, and displayTime has to be set.")
        }

        const now = new Date();
        if (!showAll && now < this.displayTime) {
            return <></>;
        }
        if (this.start < now && now < this.end) {
            return (
                <>
                    <p className="col-md-5 active">{now.toLocaleTimeString("en-US")}</p>
                    <div className="col-md-7 active">{this.toDisplay}</div>
                </>
            );
        }
        return (
            <>
                <p className="col-md-5 greyed">{this.start.toLocaleTimeString("en-US")}</p>
                <div className="col-md-7 greyed">{this.toDisplay}</div>
            </>
        );
    }
}

class EventList {
    constructor(events) {
        this.events = [...events];
        const startEvent = this.events[0];
        const endEvent = this.events[this.events.length - 1];

        if (startEvent.start == null || startEvent.displayTime == null) {
            throw Error("Start event must have a start and a display time");
        }

        if (endEvent.start == null || endEvent.end == null) {
            throw Error("End event must have an end time");
        }

        for (let i = 0; i < this.events.length; i++) {
            if (this.events[i].start == null) {
                throw Error(`Event ${i} must have a start time that is non-null`);
            }
        }

        for (let i = 1; i < this.events.length; i++) {
            this.events[i].updateFromLast(this.events[i - 1]);
        }

        for (let i = this.events.length - 2; i >= 0; i--) {
            this.events[i].updateFromNext(this.events[i + 1]);
        }

        this.events.sort((a, b) => {
            if (a.start < b.start) {
                return -1;
            }
            if (a.start > b.start) {
                return 1;
            }
            return 0;
        });
    }
}

export {Event, EventList};